enum PagesUrl {
  SerpTours = 'search',
  SerpHot = 'tury',
  SerpHotels = 'hotels/search',
  SerpRailway = 'railways/search',
  GotoHotel = 'goto/hotel',
}

enum SearchSource {
  HotelOffer = 'hotelOffer',
  RailwayTour = 'railwayTour',
}

const SEARCH_SOURCE_BY_PAGE: Partial<Record<PagesUrl, SearchSource>> = {
  [PagesUrl.SerpHotels]: SearchSource.HotelOffer,
  [PagesUrl.SerpRailway]: SearchSource.RailwayTour,
};

enum ProductType {
  TourOffer = 'tourOffer',
  RailwayTour = 'railwayTour',
  HotelOffer = 'hotelOffer',
}

interface PageContent {
  label?: string;
  title?: string;
  content?: string;
}

export { PagesUrl, ProductType, SearchSource, SEARCH_SOURCE_BY_PAGE };
export type { PageContent };
